<template>
  <router-link
    class="nav-link"
    :class="{ 'nav-link--collapsed': collapsed }"
    :to="{ name: destination }"
    :title="collapsed ? label : undefined"
  >
    <app-icon
      :icon="navItem.icon"
      :gradient="navItem.gradient"
      size="xs"
    />
    <span
      v-if="!mobileMode"
      class="nav-label"
      :class="{ 'nav-label--collapsed': collapsed }"
    >{{ label }}</span>
  </router-link>
</template>

<script>
import AppIcon from '@/components/layout/AppIcon.vue';
import { getNavItemForRoute } from '@/lib/appNavigation';

const FALLBACK_GRADIENT = 'linear-gradient(135deg, var(--color-primary), var(--color-secondary))';

export default {
  name: 'navigation-icon',
  components: {
    AppIcon,
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    navItem() {
      const resolved = getNavItemForRoute(this.destination);
      return {
        icon: resolved?.icon || this.icon,
        gradient: resolved?.gradient || FALLBACK_GRADIENT,
      };
    },
  },
  methods: {
    onResize() {
      this.mobileMode = window.innerWidth <= 767;
    },
  },
  data: () => ({
    mobileMode: false,
  }),
  props: {
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    destination: {
      type: String,
      default: '',
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
